import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTheme } from '@mui/material/styles';

/**
 * Dialog component used for confirmations.
 * @param {*} props
 * @returns
 */
export default function ConfirmDialog(props) {
  const theme = useTheme();
  const {
    setConfirmDialog,
    deleteRow,
    title,
    confirmDialog,
    confirmData = 'this data',
    confirmDelType = 'remove',
  } = props;
  const confirmMsg = `Are you sure you wish to ${confirmDelType} `;
  return (
    <Dialog
      open={confirmDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {confirmMsg} <strong>{confirmData}</strong>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setConfirmDialog(false)}
          variant="contained"
          style={{ backgroundColor: theme.palette.error.main }}
        >
          No
        </Button>
        <Button
          onClick={deleteRow}
          autoFocus
          variant="contained"
          style={{ backgroundColor: theme.palette.secondary.main }}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}
